<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import AboutUs from "@components/sections/AboutUs.svelte";
	import Blog from "@components/sections/Blog.svelte";
	import BuyCampfire from "@components/sections/BuyCampfire.svelte";
	import type { NewsListingProps } from "./NewsListingProps.js";

	const { news, products }: NewsListingProps = $props();
</script>

<Layout ogImage={news[0]?.primaryImage}>
	<Blog title="Blog" {news} class="-mt-20" />
	<BuyCampfire {products} />
	<AboutUs />
</Layout>
